<template>
  <div id="add-user" class="m-t-10">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group">
        <label for="input-nama">Nama Lengkap</label>
        <div class="form-group">
          <input
            type="text"
            name="nama"
            value=""
            id="input-nama"
            class="form-control"
            placeholder="Nama Lengkap"
            required
            v-model="nama"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-username">Username</label>
        <div class="form-group">
          <input
            type="text"
            name="username"
            value=""
            id="input-username"
            class="form-control"
            placeholder="Username"
            required
            v-model="username"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-password">Password</label>
        <div class="form-group">
          <input
            type="password"
            name="password"
            value=""
            id="input-password"
            class="form-control"
            placeholder="Password"
            autocomplete="on"
            required
            v-model="password"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-email">Email</label>
        <div class="form-group">
          <input
            type="email"
            name="email"
            value=""
            id="input-email"
            class="form-control"
            placeholder="Email"
            v-model="email"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-telpon">No. Telpon</label>
        <div class="form-group">
          <input
            type="text"
            name="telpon"
            value=""
            id="input-telpon"
            class="form-control"
            placeholder="No. Telpon"
            v-model="phone"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-role">Role</label>
        <div class="form-group">
          <select
            name="role"
            id="input-role"
            class="form-control"
            required
            v-model="role"
          >
            <option value="2">Admin</option>
            <option value="3">User</option>
            <option value="4">Viewer</option>
          </select>
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-complete">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

export default {
  name: "modal_add_user",
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      nama: "is_edit" in this.data ? this.data["user"].nama : null,
      username: "is_edit" in this.data ? this.data["user"].username : null,
      password: null,
      email: null,
      phone: "",
      role: 2,
      id_project: atob(this.$route.query.ref),
    };
  },
  methods: {
    submitForm: function () {
      if (this.phone == "") {
        this.phone = "";
      }
      if (!this.email) {
        this.email = "";
      }
      let params = {
        nama: this.nama,
        username: this.username,
        password: btoa(this.password),
        email: this.email,
        phone: this.phone,
        role: btoa(parseInt(this.role)),
        id_project: parseInt(this.id_project),
      };
      let api = process.env.VUE_APP_API_URL + "users-add";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$parent.$parent.getUser();
            $("#modalSlideUp").modal("hide");
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> User berhasil ditambahkan!',
                position: "top-right",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch(() => {
          $("#modalSlideUp").modal("hide");
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan User!',
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>